import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var pasteOptionsPluginKey = new PluginKey('paste-options');
export var ToolbarDropdownOption = /*#__PURE__*/function (ToolbarDropdownOption) {
  ToolbarDropdownOption[ToolbarDropdownOption["Markdown"] = 0] = "Markdown";
  ToolbarDropdownOption[ToolbarDropdownOption["RichText"] = 1] = "RichText";
  ToolbarDropdownOption[ToolbarDropdownOption["PlainText"] = 2] = "PlainText";
  ToolbarDropdownOption[ToolbarDropdownOption["None"] = 3] = "None";
  return ToolbarDropdownOption;
}({});